module.exports = __webpack_public_path__ + "static/media/weathered-oak-embered.07b67802.png";